// extracted by mini-css-extract-plugin
export var buttonContainer = "_5e-1";
export var fontSizeSelect = "_5e-3";
export var formatSelect = "_5e-2";
export var formats = "_5e-4";
export var hidden = "_5e-5";
export var icon = "_5e-6";
export var select = "_5e-0";